import { Component } from '@angular/core'
import { EnvDirective } from '@shared/env.directive'
import { NotificationsMenuComponent } from './notifications-menu/notifications-menu.component'
import { SearchComponent } from './search/search.component'
import { WorkspaceControlsComponent } from './workspace-controls/workspace-controls.component'
import { HeaderNameComponent } from './header-name/header-name.component'

@Component({
    selector: 'app-header-top',
    templateUrl: './header.component.html',
    imports: [
        HeaderNameComponent,
        WorkspaceControlsComponent,
        SearchComponent,
        NotificationsMenuComponent,
        EnvDirective,
    ],
})
export class HeaderComponent {}
